// extracted by mini-css-extract-plugin
export default {"Select":"SelectLib_Select__W2ArH"};